export default "__VITE_ASSET__e9bf9bc2__"